/** Keputusan titik masuk halaman resto (kobe.sassly.ai/{slug} dan /{slug}/akun). Diimpor main.tsx: hanya impor ringan. */
import { isReservedSlug, SLUG_PATTERN } from '@/shared/reservedSlugs';

export type RestaurantPage = 'home' | 'account';

export function restaurantRoute(pathname: string): { slug: string; page: RestaurantPage } | null {
  const parts = pathname.replace(/\/+$/, '').split('/').filter(Boolean);
  if (parts.length === 0 || parts.length > 2) return null;
  const slug = decodeURIComponent(parts[0]).toLowerCase();
  if (!SLUG_PATTERN.test(slug) || isReservedSlug(slug)) return null;
  if (parts.length === 2 && parts[1] !== 'akun') return null;
  return { slug, page: parts.length === 2 ? 'account' : 'home' };
}
